import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, CalendarIcon, CheckCircleIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: CalendarIcon,
    number: '1',
    title: 'Book Your Appointment',
    description: 'All services are by appointment only. Schedule online in minutes — choose your service, date, and time.'
  }, {
    icon: MapPinIcon,
    number: '2',
    title: 'We Come to You',
    description: 'For groups of 5 or more, our mobile team travels to your location. Individuals visit our Columbia, MD office.'
  }, {
    icon: CheckCircleIcon,
    number: '3',
    title: 'Fast Processing',
    description: 'Fingerprints are captured and submitted electronically to CJIS. Results typically arrive within 2-7 business days.'
  }];
  return <section className="py-24 bg-[#F8FAFF] overflow-hidden" aria-labelledby="how-it-works-heading" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="text-center mb-20" data-id="element-141">
          <h2 id="how-it-works-heading" className="text-3xl md:text-4xl font-bold text-[#1E1F55] mb-4" data-id="element-142">
            How It Works
          </h2>
          <div className="w-24 h-1 bg-[#4AA6CF] mx-auto rounded-full" aria-hidden="true" data-id="element-143"></div>
        </div>

        <div className="relative" data-id="element-144">
          {/* Connecting dashed line */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 border-t-2 border-dashed border-[#4AA6CF]/30 z-0" aria-hidden="true" data-id="element-145"></div>

          <ol className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" role="list" data-id="element-146">
            {steps.map((step, index) => <motion.li key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-147">
                <div className="relative mb-8" data-id="element-148">
                  <div className="w-24 h-24 bg-white rounded-full shadow-md flex items-center justify-center border-4 border-[#F8FAFF]" data-id="element-149">
                    <step.icon className="h-10 w-10 text-[#4AA6CF]" aria-hidden="true" data-id="element-150" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-[#1E1F55] text-white rounded-full flex items-center justify-center font-bold text-sm shadow-sm" aria-hidden="true" data-id="element-151">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-[#1E1F55] mb-3" data-id="element-152">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed max-w-xs" data-id="element-153">
                  {step.description}
                </p>
              </motion.li>)}
          </ol>
        </div>
      </div>
    </section>;
}